import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertController, LoadingController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ChangePasswordDTO } from 'src/app/auth/auth.dto';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.page.html',
  styleUrls: ['./change-password.page.scss'],
})
export class ChangePasswordPage implements OnInit, OnDestroy {
  passwordsMatch = true;
  email: string;
  userSub: Subscription;
  changePasswordSub: Subscription;
  constructor(
    private authService: AuthService,
    private loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    private router: Router
  ) {}
  ngOnInit() {
    this.userSub = this.authService.user.subscribe((user) => {
      if (user) {
        this.email = user.email;
      }
    });
  }
  ngOnDestroy() {
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
    if (this.changePasswordSub) {
      this.changePasswordSub.unsubscribe();
    }
  }
  updatePassword(form: NgForm) {
    const password = form.value.newPassword;
    const confirm = form.value.confirmPassword;
    const currentPass = form.value.currentPassword;
    if (password !== confirm) {
      this.passwordsMatch = false;
      return;
    }
    this.passwordsMatch = true;
    this.loadingCtrl
      .create({ keyboardClose: true, message: 'Please wait...' })
      .then((loadingEl) => {
        loadingEl.present();
        const dto: ChangePasswordDTO = {
          email: this.email,
          currentPassword: currentPass,
          newPassword: password,
        };
        this.changePasswordSub = this.authService
          .changePassword(dto)
          .subscribe({
            next: (resp) => {
              if (resp) {
                loadingEl.dismiss();
                form.reset();
                this.alertCtrl
                  .create({
                    header: 'Success',
                    message: 'Password updated successfully.',
                    buttons: [{ text: 'Dismiss' }],
                  })
                  .then((alertEl) => alertEl.present());
              } else {
                loadingEl.dismiss();
                this.alertCtrl
                  .create({
                    header: 'Incorrect Password',
                    message:
                      'Forgot your password? Sign out and reset it from the login page!',
                    buttons: [{ text: 'Dismiss' }],
                  })
                  .then((alertEl) => alertEl.present());
              }
            },
            error: () => {
              loadingEl.dismiss();
            },
          });
      });
  }

  goToChangePassword() {
    this.router.navigateByUrl('/change-password');
  }
}
